import { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Stack } from '@mui/material';
import moment from 'moment';

import DatePickerComponent from "../Field/DatePickerComponent";
import TimePickerComponent from "../Field/TimePickerComponent";

const EventCompleteModal = ({ eventDetails, setShowCompleteViewModal }) => {
    const { t } = useTranslation();

    const [showType, setShowType] = useState(false);
    const [showKindType, setShowKindType] = useState(false);
    const [appointmentType, setAppointmentType] = useState("");
    const [appointmentKindType, setAppointmentKindType] = useState("");
    const [value, setValue] = useState(null);

    const handleShowCreateModal = (e) => {
        e.preventDefault();
        setShowCompleteViewModal()
    };
    const handleAppointmentType = (e, data) => {
        e.preventDefault();
        setAppointmentType(data);
    };
    const handleAppointmentKindType = (e, data) => {
        e.preventDefault();
        setAppointmentKindType(data);
    };
    const handleDateDataFromChild = (data) => {
        
    };
    const handleTime = (newValue) => {
        setValue(newValue);
        // sendTimeFromChild({ "name": name, "time": moment(newValue.$d).format() });
    }

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[34rem] p-2.5 sm:p-6 space-y-2 sm:space-y-4">                
                <div className="flex justify-between items-center">
                    <div className='flex items-center space-x-2'>
                        <h3 className="text-lg font-semibold capitalize">
                            { t('complete appointment')}
                        </h3>
                    </div>
                    <button onClick={(e) => handleShowCreateModal(e)} className="text-gray-500 hover:text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div className='space-y-2'>
                    <div className='grid grid-cols-2 gap-2'>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('actual appointment time')}</label>
                            </div>
                            <Stack sx={{ paddingTop: 0 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['TimePicker']} sx={{ paddingTop: 0 }}>
                                        <TimePicker
                                            name="time"
                                            value={value}
                                            onChange={(newValue) => handleTime(newValue)}
                                            className="text-sm sm:text-base"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "&:hover > fieldset": {
                                                    border: '1px solid #F1F1F1', // Border on hover
                                                    width: 'auto'
                                                    },
                                                    "& fieldset": {
                                                    borderColor: "#F1F1F1",
                                                    border: '1px solid #F1F1F1',
                                                    borderRadius: '8px',
                                                    },
                                                    "& .MuiInputBase-input": {
                                                    fontSize: '1rem',
                                                    color: '#000',
                                                    padding: '11px 13px', // Updated padding (top/bottom, left/right)
                                                    background: "#FFF",
                                                    },
                                                },
                                                "& .MuiPickersClock-circle": {
                                                    backgroundColor: '#e0f7fa', // Custom background for clock circle
                                                }
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Stack>
                        </div>
                        <div className="space-y-1">
                            <div className='flex items-start space-x-2'>
                                <label className='text-xs sm:text-sm capitalize text-light-700'>{t('follow up date')} <span className="text-xs">(if any)</span></label>
                            </div>
                            <div className='flex justify-between bg-white border border-background-normal rounded-md text-sm sm:text-base'>
                                <DatePickerComponent setDataFromChild={handleDateDataFromChild} startDate={dayjs()} dateInput={dayjs()} name={'date'}/>
                            </div>
                        </div>
                    </div>
                    <textarea className="bg-white border border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={3} columns={10} placeholder="write comment here"></textarea>
                </div>
                <div className="flex justify-between items-center text-sm sm:text-base">
                    <button onClick={(e) => handleShowCreateModal(e)} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                        { t('close')}
                    </button>
                    <button className="px-4 py-2 bg-blue-normal text-white rounded-lg capitalize">
                        { t('complete appointment')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EventCompleteModal;
